import { render } from "./CashflowPopupWarning.vue?vue&type=template&id=670224fe"
import script from "./CashflowPopupWarning.vue?vue&type=script&lang=js"
export * from "./CashflowPopupWarning.vue?vue&type=script&lang=js"

import "./CashflowPopupWarning.vue?vue&type=style&index=0&id=670224fe&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__